import request from '@/router/axios'

export function fetchMemberGoodsRecordPage(params) {
  return request({
    url: '/mall/admin/member-goods-record/page',
    method: 'get',
    params
  })
}

export function getMemberGoodsRecordDetail(id) {
  return request({
    url: '/mall/admin/member-goods-record/' + id,
    method: 'get'
  })
}

export function entryCourierInfo(data) {
  return request({
    url: '/mall/admin/member-goods-record/courier',
    method: 'put',
    data
  })
}


export function exportMemberGoodsRecord(data) {
  return request({
    url: '/mall/admin/member-goods-record/export',
    method: 'post',
    data,
  })
}
